import { gql } from "@apollo/client";
import { SELECT_OPTION_FIELDS } from "graphql/types/SelectOptionType";

export const LIST_DSP_BIND_VALUE_OPTIONS = gql`
    query ListDspBindValueOptions {
        listDspBindValueOptions {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;

export interface ListDspBindValueOptionsResponse {
    listDspBindValueOptions: Array<{ value: string; label: string }>;
}
